module.exports = __webpack_public_path__ + "img/error.5719b9e4.jpg";